'use client';

import Script from 'next/script';

export default function GoogleAnalytics({ ga_id }: { ga_id: string }) {
    console.log('ANALYTICS_DEBUG: Rendering GA component with ID:', ga_id);
    return (
        <>
            <Script
                strategy="afterInteractive"
                src={`https://www.googletagmanager.com/gtag/js?id=${ga_id}`}
            />
            <Script
                id="google-analytics"
                strategy="afterInteractive"
                dangerouslySetInnerHTML={{
                    __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${ga_id}', {
              page_path: window.location.pathname,
            });
          `,
                }}
            />
        </>
    );
}
